"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Localization = void 0;
var _react = require("react");
var _reactRedux = require("react-redux");
var _constants = require("../utils/constants");
var _translations = require("../entities/translations");
var _methods = require("./utils/methods");
var _functions = require("../utils/functions");
/**
 * Localization wrap
 * @param {Element} children
 * @param {boolean} detectLocale
 * @param {string} initialLocale
 * @returns {Element}
 * @public
 */

const Localization = _ref => {
  let {
    children,
    detectLocale = false,
    initialLocale = (0, _functions.getFromLocalStorage)('locale') || _constants.defaultLocale
  } = _ref;
  const dispatch = (0, _reactRedux.useDispatch)();
  (0, _react.useEffect)(() => {
    dispatch((0, _translations.setLocaleAction)(detectLocale ? (0, _methods.detectDeviceLocale)() || initialLocale : initialLocale));
  }, [detectLocale, dispatch, initialLocale]);
  return children;
};
exports.Localization = Localization;